import TalentListPage from '../components/Talent/TalentListPage'

const RejectedCandidates = () => {
  return (
    <>
      <title>Rejected Candidates | Talent Service</title>
      <TalentListPage
        talentType="candidate"
        statusNames="Not Approved,Denied,Refused"
        pageTitle="Rejected Candidates"
        pageDescription="Candidates with Not Approved, Denied, or Refused status"
      />
    </>
  )
}

export default RejectedCandidates
